import { signify } from "react-signify";

export const sFormData = signify({ email: "", password: "" });
export const sFormError = signify({ email: "", password: "" });
export const sIsParent = signify(false);
